import React from 'react';
import { getTrans, replaceParams } from '@/utils/tools';
import { Copywriting } from '@/utils/constants';

import './index.scss';

interface UnreadMessagesProps {
  num: number;
}

export default class UnreadMessages extends React.Component<UnreadMessagesProps> {
  render() {
    const { num } = this.props;
    const transKey = num > 1 ? Copywriting.UNREAD_MSGS : Copywriting.UNREAD_MSG;

    return (<div className="unread-messages">
      <div className="line"></div>
      <span className="text">{replaceParams(getTrans(transKey), { num })}</span>
      <div className="line"></div>
    </div>);
  }
}
